/*global angular */

(function (angular) {
'use strict';

var book = angular.module('book', [
    'book.controllers',
    'book.services',
    'book.directives',
    'book.filters'
]);

book.constant('SystemShelf', {
    wantRead: 1,
    readNow: 2,
    read: 3,
    favorite: 4,
    isSystem: function (shelfId) {
        return shelfId >= 1 && shelfId <= 4;
    },
    isReads: function (shelfId) {
        return shelfId >= 1 && shelfId <= 3;
    },
    readIds: function () {
        return [1, 2, 3];
    }
});

book.constant('CollectionTemplateTypes', {
    list: 1,
    short: 2,
    mixed: 3
});

book.constant('FeedbackCategories', {
    bookInfoMistake: 7,
    authorInfoMistake: 11
});
}(angular));
